var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.00488H0V20.0051H24V4.00488Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.00488H0V8.00471H24V6.00488Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.0049H0V12.0047H24V10.0049Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.0049H0V16.0047H24V14.0049Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.0049H0V20.0047H24V18.0049Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.00488H0V12.6204H12V4.00488Z",
    fill: "#2E52B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67923 7.53418L4.48596 8.12874H3.86084L4.36667 8.49601L4.1734 9.09052L4.67923 8.72326L5.18473 9.09052L4.99151 8.49601L5.49734 8.12874H4.87217L4.67923 7.53418Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87217 10.2742L4.67923 9.67969L4.48596 10.2742H3.86084L4.36667 10.6415L4.1734 11.236L4.67923 10.8687L5.18473 11.236L4.99151 10.6415L5.49734 10.2742H4.87217Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23012 10.2742L2.03714 9.67969L1.84388 10.2742H1.21875L1.72458 10.6415L1.53131 11.236L2.03714 10.8687L2.54269 11.236L2.34947 10.6415L2.8552 10.2742H2.23012Z",
    fill: "#F0F0F0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03714 7.53418L1.84388 8.12874H1.21875L1.72458 8.49601L1.53131 9.09052L2.03714 8.72326L2.54269 9.09052L2.34947 8.49601L2.8552 8.12874H2.23012L2.03714 7.53418Z",
    fill: "#F0F0F0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67923 5.38867L4.48596 5.98328H3.86084L4.36667 6.35059L4.1734 6.94511L4.67923 6.5778L5.18473 6.94511L4.99151 6.35059L5.49734 5.98328H4.87217L4.67923 5.38867Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03714 5.38867L1.84388 5.98328H1.21875L1.72458 6.35059L1.53131 6.94511L2.03714 6.5778L2.54269 6.94511L2.34947 6.35059L2.8552 5.98328H2.23012L2.03714 5.38867Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32078 7.53418L7.12757 8.12874H6.50244L7.00822 8.49601L6.81505 9.09052L7.32078 8.72326L7.82638 9.09052L7.63311 8.49601L8.13894 8.12874H7.51382L7.32078 7.53418Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51382 10.2742L7.32078 9.67969L7.12757 10.2742H6.50244L7.00822 10.6415L6.81505 11.236L7.32078 10.8687L7.82638 11.236L7.63311 10.6415L8.13894 10.2742H7.51382Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1559 10.2742L9.96288 9.67969L9.76961 10.2742H9.14453L9.65027 10.6415L9.45705 11.236L9.96288 10.8687L10.4684 11.236L10.2752 10.6415L10.781 10.2742H10.1559Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96288 7.53418L9.76961 8.12874H9.14453L9.65027 8.49601L9.45705 9.09052L9.96288 8.72326L10.4684 9.09052L10.2752 8.49601L10.781 8.12874H10.1559L9.96288 7.53418Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32078 5.38867L7.12757 5.98328H6.50244L7.00822 6.35059L6.81505 6.94511L7.32078 6.5778L7.82638 6.94511L7.63311 6.35059L8.13894 5.98328H7.51382L7.32078 5.38867Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96288 5.38867L9.76961 5.98328H9.14453L9.65027 6.35059L9.45705 6.94511L9.96288 6.5778L10.4684 6.94511L10.2752 6.35059L10.781 5.98328H10.1559L9.96288 5.38867Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlagIcon);
export default __webpack_public_path__ + "static/media/us-flag-icon.0381b9a84fb69353d2423c4b1163bffe.svg";
export { ForwardRef as ReactComponent };